<fz-main-view>
  <fz-static-view>
    <div class="page-not-found">
      <div class="container">
        <div class="container__message">
          <fz-empty-list
            [title]="'Oops!'"
            [showLoginButton]="false"
            [loggedOutMessage]="
              'The tournament you are looking for is not available anymore.'
            "
          ></fz-empty-list>
        </div>
        <div>
          <a
            type="button"
            mat-flat-button
            color="primary"
            routerLink="/"
            routerLinkActive="active"
            >Go To Play Page</a
          >
        </div>
        <div>
          <p class="text-info">
            FantaZ strives to provide an ideal gaming experience. Please make
            sure your internet connectivity is stable before clicking "Play Now"
            to enter the tournament. In the case where connectivity issues
            arise, your score not be recorded. You will be returned your entry
            fee in ths case.
          </p>
        </div>
      </div>
    </div>
    <fz-footer [theme]="colorScheme"></fz-footer>
  </fz-static-view>
</fz-main-view>
